// extracted by mini-css-extract-plugin
export default {"fulfillmentOptionsDropdownField":"FulfillmentOptionsDropdown_fulfillmentOptionsDropdownField__Ane13"};